module.exports = __webpack_public_path__ + "static/media/settings.9e37ba7b.svg";